module.exports = __webpack_public_path__ + "img/full6-min.33f49b3b.png";